import { formatMoney, formatDate } from '../../lib/utils'
import type { ReferenciaPluggy } from '../../types'
import type { ResumoImportacao } from '../../lib/paresImportacao'

/** Resumo antes de confirmar: total da fatura depois da importação x total do arquivo, com as contagens de cada decisão. */
export function ResumoAntesDeConfirmar({ resumo, origem, destinoRotulo, referenciaPluggy }: { resumo: ResumoImportacao; origem: 'PDF' | 'CSV'; destinoRotulo: string; referenciaPluggy?: ReferenciaPluggy | null }) {
  const contagens: [number, string][] = [
    [resumo.importar, 'importar'], [resumo.manter, 'manter'], [resumo.trocar, 'trocar'], [resumo.diferentes, 'importar como diferentes'],
    [resumo.mover, 'mover'], [resumo.excluir, 'excluir'], [resumo.parcelasOutras, 'parcelas apagadas em outras faturas'],
  ]
  return (
    <div className="space-y-1 rounded-lg border border-line p-3 text-13">
      <p className="font-medium text-white">Resumo da importação{destinoRotulo ? ` em ${destinoRotulo}` : ''}</p>
      <dl className="grid grid-cols-2 gap-2 sm:grid-cols-4">
        <div><dt className="text-2xs text-muted">Total atual da fatura</dt><dd className="font-semibold text-white">{formatMoney(resumo.totalAtual)}</dd></div>
        <div><dt className="text-2xs text-muted">Depois de importar</dt><dd className="font-semibold text-white">{formatMoney(resumo.totalProjetado)}</dd></div>
        <div><dt className="text-2xs text-muted">Total do {origem}</dt><dd className="font-semibold text-white">{formatMoney(resumo.totalArquivo)}</dd></div>
        <div>
          <dt className="text-2xs text-muted">Conferência</dt>
          <dd className={`font-semibold ${resumo.igual ? 'text-income' : 'text-warning'}`}>{resumo.igual ? 'Igual ao extrato' : `Diferença ${formatMoney(resumo.diferenca)}`}</dd>
        </div>
      </dl>
      {referenciaPluggy && (
        <p className="text-12 text-muted" title={referenciaPluggy.observacao ?? undefined}>
          <i className="ri-information-line" aria-hidden /> Saldo do cartão na Pluggy: <strong className="text-white">{formatMoney(referenciaPluggy.saldoCartao)}</strong> (em {formatDate(referenciaPluggy.data)}).
          {' '}Pode ser a fatura aberta ou o limite utilizado; use só como conferência.
        </p>
      )}
      <p className="text-12 text-muted">{contagens.filter(([n]) => n > 0).map(([n, t]) => `${n} ${t}`).join(' · ') || 'Nada a fazer.'}</p>
    </div>
  )
}
